import { render, staticRenderFns } from "./Top5.vue?vue&type=template&id=421ca00c&scoped=true&"
import script from "./Top5.vue?vue&type=script&lang=js&"
export * from "./Top5.vue?vue&type=script&lang=js&"
import style0 from "./Top5.vue?vue&type=style&index=0&id=421ca00c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421ca00c",
  null
  
)

export default component.exports